export const templateKeys = ['train-adventure', 'fiery-route', 'orbital-bridge', 'turbo-duel', 'balance-arena', 'basket-learning', 'goal-arena', 'billionaire-quiz', 'ufo-adventure', 'lane-rally', 'station-run'] as const;
export type TemplateKey = (typeof templateKeys)[number];

export type TemplateDefinition = {
  key: TemplateKey;
  name: string;
  description: string;
  maxLevels: number;
};

export const templateDefinitions: Record<TemplateKey, TemplateDefinition> = {
  'station-run': { key: 'station-run', name: 'İstasyon Koşusu', description: 'Raylarda koş, engellerden kaç, altınları topla ve her istasyonda soruyu bilerek yolculuğunu tamamla.', maxLevels: 20 },
  'lane-rally': { key: 'lane-rally', name: 'Şerit Rallisi', description: 'Gaza bas, doğru cevabın şeridine geç ve 3B otoyolda altınları toplayarak bitişe ulaş.', maxLevels: 20 },
  'ufo-adventure': { key: 'ufo-adventure', name: 'UFO Macerası', description: 'Uzayın derinliklerinde uç, doğru cevap geçidini seç ve keşif yolculuğunu tamamla.', maxLevels: 20 },
  'train-adventure': {
    key: 'train-adventure',
    name: 'Tren Macerası',
    description: 'Hareket eden cevapları doğru vagonlara indir.',
    maxLevels: 5,
  },
  'fiery-route': {
    key: 'fiery-route',
    name: 'Alevli Rota',
    description: 'Kıvıl ile mozaik labirentte Çiselerden kaçıp doğru geçidi bul.',
    maxLevels: 10,
  },
  'orbital-bridge': {
    key: 'orbital-bridge',
    name: 'Yörünge Köprüsü',
    description: 'Doğru enerji modülünü seç, köprüyü tamamla ve keşif aracını ileri taşı.',
    maxLevels: 10,
  },
  'turbo-duel': {
    key: 'turbo-duel',
    name: 'Turbo Düellosu',
    description: 'Soruları yanıtla, turboyu ateşle ve iki rakibini bitiş çizgisinde geride bırak.',
    maxLevels: 10,
  },
  'balance-arena': {
    key: 'balance-arena',
    name: 'Denge Arenası',
    description: 'Soruları cevapla, gökyüzü platformunda dengeni koru ve düşmeden dayan.',
    maxLevels: 25,
  },
  'basket-learning': {
    key: 'basket-learning',
    name: 'Potada Öğren',
    description: 'Soruları cevapla, atışını yap ve gece finalinde seri basketlerle puanını yükselt.',
    maxLevels: 20,
  },
  'goal-arena': {
    key: 'goal-arena',
    name: 'Gol Arenası',
    description: 'Soruları cevapla, birinci şahıs stadyumunda şutunu çek ve kaleciyi geç.',
    maxLevels: 20,
  },
  'billionaire-quiz': {
    key: 'billionaire-quiz',
    name: 'Kim Milyarder Olmak İster?',
    description: 'Soruları yanıtla, kasanı büyüt ve sürpriz bonus kartlarıyla final ödülüne ulaş.',
    maxLevels: 20,
  },
};

export function templateName(key: TemplateKey): string {
  return templateDefinitions[key].name;
}
